import { Navigate } from 'react-router-dom';
import { getAuthPayload, getStoredToken, getUserRoles, isTokenExpired } from '../utils/auth';

// redirects to signin if user is not logged in or doesn't have the right role
function ProtectedRoute({ children, allowedRoles }) {
  const token = getStoredToken();
  if (!token) return <Navigate to="/" replace />;

  const payload = getAuthPayload();
  if (!payload) return <Navigate to="/" replace />;

  if (isTokenExpired(payload)) {
    localStorage.removeItem('token');
    return <Navigate to="/" replace />;
  }

  const userRoles = getUserRoles(payload);

  if (allowedRoles && !allowedRoles.some((r) => userRoles.includes(r))) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedRoute;
